import React from 'react';

import JiraIssues from '../../images/jira-issues.svg';

export const JiraIssuesLogo = () => {
  return <img height="18" src={JiraIssues} alt="Jira Issues logo" />;
};
